import { ColDef } from "ag-grid-community";
import { ProcessedHistoryData } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";

export const budgetDetailsHistoryUsedComparator: ColDef<ProcessedHistoryData>["comparator"] =
  (_, __, nodeA, nodeB) => {
    const current = nodeA.data?.used;
    const next = nodeB.data?.used;

    if (typeof current !== "number") return -1;
    if (typeof next !== "number") return 1;

    return current > next ? 1 : -1;
  };

export const getBudgetDetailsHistoryVarianceComparator =
  (
    key: keyof Pick<
      ProcessedHistoryData,
      "budgetVarianceCostBased" | "budgetVariancePercentage"
    >,
  ): ColDef<ProcessedHistoryData>["comparator"] =>
  (_, __, nodeA, nodeB) => {
    const current = nodeA.data?.[key];
    const next = nodeB.data?.[key];

    if (typeof current !== "number") return -1;
    if (typeof next !== "number") return 1;

    return current > next ? 1 : -1;
  };
